export const cap = (value: string = "") => {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

export const capPhrase = (value: string) => {
    if (!value) return '';
    return value.split(' ').map((v) => cap(v)).join(' ');
}